import React, { useState } from "react"
import { Button, Col, Divider, Drawer, Input, Row, Typography, message, Upload, Select } from "antd"
import { UploadOutlined } from "@ant-design/icons"
import { doc, updateDoc } from "firebase/firestore"
import { db, storage } from "../../../../firebase/config" // Assuming you have firebase storage configured
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage"
import { loadingSpinWithBg } from "../../../../components/Elements/LoadingSpinner"

const { TextArea } = Input
const { Text } = Typography

export default function TechnicalRequest({ data }) {
  const [open, setOpen] = useState(false)
  const [technicalComment, setTechnicalComment] = useState("")
  const [selectedLanguage, setSelectedLanguage] = useState("LV")
  const [file, setFile] = useState(null) // State to track the uploaded file
  const [isLoading, setIsLoading] = useState(false)

  const showDrawer = () => {
    setOpen(true)
  }
  const onClose = () => {
    setOpen(false)
  }

  const props = {
    name: "file",
    beforeUpload: (file) => {
      setFile(file)
      return false // Prevent automatic upload
    },
    onRemove: () => {
      setFile(null)
    },
  }

  // Request for technical page
  const requestForTechincal = async (record) => {
    const docref = doc(db, "priceCalculation", record.id)

    try {
      setIsLoading(true) // Start loading
      let technicalFileUrl = ""
      let hasTechnicalFileUrl = false

      if (file) {
        // Upload the file to Firebase Storage
        const storageRef = ref(storage, `technicalFiles/${record.id}/${file.name}`)
        const uploadTask = uploadBytesResumable(storageRef, file)

        uploadTask.on(
          "state_changed",
          (snapshot) => {
            // Optional: handle progress updates here if you want to show a progress bar or similar
          },
          (error) => {
            // Handle unsuccessful uploads
            console.error(error)
            message.error("File upload failed: " + error.message)
          },
          () => {
            // Handle successful uploads on complete
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
              technicalFileUrl = downloadURL
              hasTechnicalFileUrl = true

              // Update document in Firestore
              updateDoc(docref, {
                hasTechincalPage: 1,
                technicalLanguage: selectedLanguage,
                technicalFileUrl: technicalFileUrl,
                hasTechnicalFileUrl: hasTechnicalFileUrl,
                technicalComment: technicalComment,
              })
                .then(() => {
                  message.success("Request submitted successfully")
                  setIsLoading(false) // Stop loading
                })
                .catch((error) => {
                  console.error(error)
                  message.error("Failed to update document: " + error.message)
                  setIsLoading(false)
                })
            })
          }
        )
      } else {
        // No file to upload, just update the document
        await updateDoc(docref, {
          hasTechincalPage: 1,
          technicalLanguage: selectedLanguage,
          technicalComment: technicalComment,
        })
        message.success("Request submitted successfully")
        setIsLoading(false) // Stop loading
      }
    } catch (error) {
      console.error(error)
      message.error("Something went wrong: " + error.message)
      setIsLoading(false) // Stop loading
    }
  }

  // Handle language
  const handleSelectLanguage = (value) => {
    setSelectedLanguage(value)
  }

  if (isLoading) {
    return loadingSpinWithBg(75, "Uploading File")
  }

  return (
    <div>
      <Button size="small" disabled={data.clientisLead === true} onClick={showDrawer}>
        Request
      </Button>
      <Drawer title="New Technical Request" onClose={onClose} open={open}>
        <Row gutter={[15, 15]}>
          <Col span={24}>File for Technical Pages</Col>
          <Col span={24}>
            <Upload {...props}>
              <Button block icon={<UploadOutlined />}>
                Click to Upload
              </Button>
            </Upload>
          </Col>
          <Divider />
          <Col span={24}>
            <Text>Comment on Technical Page</Text>
          </Col>
          <Col span={24}>
            <TextArea rows={5} onChange={(event) => setTechnicalComment(event.target.value)} />
          </Col>
          <Divider />
          <Col span={24}>
            <Text>Select Language for technical</Text>
          </Col>
          <Col span={24}>
            <Select
              style={{ width: 120 }}
              defaultValue={"LV"}
              onChange={handleSelectLanguage}
              options={[
                { value: "LV", label: "LV" },
                { value: "EN", label: "EN" },
              ]}
            />
          </Col>
          <Divider />
          <Col span={24}>
            <Button type="primary" onClick={() => requestForTechincal(data)} block>
              Request
            </Button>
          </Col>
        </Row>
      </Drawer>
    </div>
  )
}
